module.exports = __webpack_public_path__ + "img/sanjx.ec7c418e.png";